// extracted by mini-css-extract-plugin
module.exports = {"title":"delete_review__title___nOEma _type__vx_text-2___Qizsf","delete-button":"delete_review__delete-button___ki2QT"};